import React, { Component } from 'react';
import { Button } from "reactstrap"
import { fetchData } from "../common/networkRequests";
import { getRequiredField } from '../oro-module/commonFunctions';
import { handleConfirmSubmit } from "../oro-module/ajaxdata"


class SubmitCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmit: false,
      submitConfirm: false
    };
    // this.handleSubmit = this.handleSubmit.bind(this);
    // this.toggleDeletingDropdown = this.toggleDeletingDropdown.bind(this);
  }

  handleSubmit = () => {
    let { submitConfirm } = this.state;
    this.setState({ submitConfirm: true })
  }

  handleConfirmCancel = () => {
    this.setState({ submitConfirm: false })
  }

  render() {
    let {
      alerts,
      unsavedChanges,
      errorMessages,
      currentPage,
      pageData,
      LocalVars,
      showButtons,
      fileFolder, formActions
    } = this.props.parentState

    let otherPageData={submit_type:"submit"};
    return (
      <div>
        {!fileFolder.isOpen && showButtons.submit && (
          <div className="row">
            {!this.state.isSubmit && !this.state.submitConfirm && <Button
              outline
              color="success"
              className={`col-2 offset-5 black-submit-button`}
              onClick={this.handleSubmit}
              // onClick={this.handleConfirmSubmit}
              id="main-form-submit-button"
            >
              {" "}
              {formActions && formActions.submit && formActions.submit.text && (
                <span>{formActions.submit.text}</span>
              )}
              {(!formActions ||
                !formActions.submit ||
                !formActions.submit.text) && <span>Submit</span>}

            </Button>}
            {this.state.submitConfirm && <Button
              outline
              color="success" 
              className={`col-1 offset-5 black-submit-button`}
              // onClick={this.handleSubmit}
              onClick={()=>handleConfirmSubmit({current:this,otherPageData})}
              id="main-form-submit-button"
            >YES</Button>
            }
            {this.state.submitConfirm && <Button
              outline
              color="danger"
              style={{ marginLeft: "5px" }}
              className={`col-1  black-submit-button`}
              // onClick={this.handleSubmit}
              onClick={this.handleConfirmCancel}
              id="main-form-submit-button"
            >Cancel</Button>
            }

            {this.state.isSubmit &&
              <div className={`col-2 offset-5 `}> <img width="20"  style={{ textAlign: "center", }} src="/images/gif/spinner-min.gif" /> </div>
            }
          </div>
        )}
      </div>
    );
  }
}

export default SubmitCustom;